import namor from "namor";

const range = len => {
  const arr = [];
  for (let i = 0; i < len; i++) {
    arr.push(i);
  }
  return arr;
};

// const newPerson = () => {
//   return {
//     firstName: namor.generate({ words: 1, numbers: 0 }),
//     lastName: namor.generate({ words: 1, numbers: 0 }),
//     appNumber: Math.floor(Math.random() * 30),
//     email: Math.floor(Math.random() * 100),
//     phone: Math.floor(Math.random() * 100),
//     status: "Not yet admitted"
//   };
// };

const newPerson = () => {
  return {
    firstName: "Olajide joshua",
    lastName: "Tomiwa",
    appNumber: "111",
    email: "email@me.com",
    phone: "08136023230",
    status: "Not yet admitted"
  };
};


export default function makeData(...lens) {
  const makeDataLevel = (depth = 0) => {
    const len = lens[depth];
    return range(len).map(d => {
      return {
        ...newPerson(),
        subRows: lens[depth + 1] ? makeDataLevel(depth + 1) : undefined
      };
    });
  };

  return makeDataLevel();
}
